<template>
  <header class="text-center mb-4">
      <h2 class="skin-page-heading">
          Understanding your benefit entitlements
      </h2>
  </header>

  <div class="row">
    <div class="col-md-12">
        <p>
            Many working people are also entitled to benefits. If you are, make sure you are claiming what you are entitled to. This may help you pay some costs and hopefully let you save more into your pension pots to fund retirement.
        </p>
        <p>
            Many people currently in retirement are also entitled to benefits. Many of these retirement benefits go unclaimed. You should make sure you claim benefits if you are entitled to them, as they can help support your overall retirement needs.
        </p>
        <p>
            Like many entities trying to help people understand available benefits, we have teamed up with <a href="https://inbest.ai" target="_blank">Inbest</a>. They provide a great free benefits journey which we have added in our site below. This can help you understand what you may be entitled to, help you save more for retirement, or add some income into your Guiide plan if you have already retired. If you can claim additional income in retirement, just add it into other income in your plan. Give it a try below.
        </p>
    </div>
    <div>
      <iframe
        id="inbest_iframe"
        :src="inbestSource"
        frameborder="0"
        width="100%"
        style="height: 1500px;"
      ></iframe>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Benefits",
  // Blocked by CSP. Hash won't work because b.data changes the script. Nonce might but out of time.
  // mounted() {
  //   const eventMethod = window.addEventListener
  //     ? "addEventListener"
  //     : "attachEvent";
  //   const eventer = window[eventMethod];
  //   const messageEvent = "attachEvent" == eventMethod ? "onmessage" : "message";

  //   eventer(
  //     messageEvent,
  //     function(a) {
  //       const b = a.data;

  //       if (b) {
  //         const a = document.getElementById("inbest_iframe");
  //         if ("height" === b.type) {
  //           a.setAttribute("style", `height: ${b.data}px;`);
  //         } else if ("scrollToTop" === b) {
  //           const b = a.getBoundingClientRect();
  //           const c = b.top + window.scrollY - 90;
  //           window.scrollTo(0, c);
  //         }
  //       }
  //     },
  //     !1
  //   );
  // },
  computed: {
    inbestSource: function() {
      const userId = this.$store.state.retiree.id;
      return `https://benefits.inbest.ai/iframe/guiide?user_id=${userId}`;
    }
  }
});
</script>
